// this file contain all routing path
// Client route
export const HOME_PAGE = "/";
export const ASSET_CATEGORY = "/search-asset/:assetCategory/:id";
export const TRANSPORT_COMPANY_FORM = "/transportation-company";
export const FINANCE_COMPANY_FORM = "/finance-company";
export const ASSETS = "/asset-categories/assets";
export const SEARCH = "/search";
export const COMPLETE_PROFILE = "/completed-profile/:id";
export const READ_ALL_NOTOFICATIONS = "/readAllNotifications";
export const DEALS_TAB =
  "/:assetClass/:assetCategory/:assetMake/:id/assets/deals";
export const DEALS_TAB_BID =
  "/:assetClass/:assetCategory/:assetMake/:id/:bidId/:assetId/assets/deals";
export const ASSET_DETAIL =
  "/eqn-assets/:assetClass/:assetCategory/:assetMake/:assetModel/:id/:userId?/:token?";
export const SHIPPED_COMPANY_FORM = "/get-asset-shipped";
export const ABOUT_US = "/aboutUs";
export const CAREERS = "/careers";
export const WORKING = "/working";
export const NEWS = "/news";
export const SITEMAP = "/site-map";
export const FAQS = "/FAQs";
export const UPCOMING_FEATURES = "/upcoming-features";
export const BETA_TEASTER = "/beta-tester";
export const BUY = "/how-to-buy";
export const SELL = "/how-to-be-a-seller";
export const PLATFORM_HEALTH = "/platform-health";
export const MOBILE_APP = "/mobile-app";
export const SET_PASSWORD = "/auth/set-password/:id";

//Base route
export const ASSET_DETAIL_PAGE = "/admin/all-assets/:id/asset-detail";
export const CATEGORY_PAGE = "/admin/categories";
export const ROLE_MODULE = "/admin/roles-module";
export const ROLE_PAGE = "/admin/roles-permissions";
export const NON_CLOSEABLE_MODAL = "/admin/approved";
export const DASHBOARD_PAGE = "/admin/dashboard";
export const RESET_PASSWORD = "/admin/reset-password";
export const FORCE_PASSWORD = "/admin/force-reset-password";
export const ORGANIZATION_LIST = "/admin/organizations-list";
export const INSPECTION_LIST = "/admin/inspection-list";
export const BUYER_SELLER_LIST = "/admin/buyer-seller-list";
export const ALL_ASSET_PAGE = "/admin/all-assets";
export const UNDER_NEGOTIATION = "/admin/assets-under-negotiation";
export const UNDER_NEGOTIATION_BUYER = "/admin/buying-assets-under-negotiation";
export const SELLER_OFFER = "/admin/seller-offer";
export const SELLER_OFFER_BUYER = "/admin/buying-seller-offer";
export const INQUIRY_TAB = "/admin/inquiries/list";
export const INQUIRY_TAB_SELLER = "/admin/inquiries/seller-list";
export const CURRENCIES = "/admin/currencies";
export const BUYER_ASSET_LIST = "/admin/buyer-assets";
export const PURCHASED_ASSETS = "/admin/purchased-assets";
export const SAVED_ASSETS = "/admin/saved-assets/:listId?";
export const WANT_ASSETS = "/admin/want-to-buy-assets";
export const EXTEND_TIMER_REQ = "/admin/assets-extend-timer-request";
export const INQUIRES = "/admin/inquiries";
export const ASSETS_PAGE = "/admin/seller-assets";
export const SOLD_ASSETS = "/admin/sold-assets";
export const BECOME_SELLER = "/admin/sellerinfo";
export const SUBSCRIPTION_SUCEESS = "/admin/subscription/success";
export const SUBSCRIPTION_ERROR = "/admin/subscription/error";
export const WORLD_DATA = "/admin/world-data";
export const GLOBAL_SETTING = "/admin/global-setting";
export const SUBSCRIPTION_PAGE = "/admin/subscription";
export const LOGISTICS_PARTNER = "/admin/logistic-partner";
export const LOGISTICS_TYPE = "/admin/logistic-type";
export const FINANCE_PARTNER = "/admin/finance-partner";
export const SERVICE_OFFERED = "/admin/service-offered";
export const COMPANY_TYPE = "/admin/company-type";
export const BUSINESS_TYPE = "/admin/business-type";
export const SUBSCRIPTIONS = "/admin/company-subscriptions";
export const ADMIN_ASSET_CATEGORY = "/admin/asset-categories";
export const FINANCE_COMPANY_PAGE = "/admin/finance-companies";
export const TRANSPORT_COMPANY_PAGE = "/admin/transport-companies";
export const MAKE_PAGE = "/admin/asset-make";
export const MODEL_PAGE = "/admin/asset-model";
export const ACTIVE_SUBSCRIPTIONS = "/admin/active-subscriptions";
export const BADGE_PAGE = "/admin/master-badges";
export const ASSET_CLASS = "/admin/asset-class";
export const USER_PROFILE = "/admin/user-profile";
export const SUPPORT = "/admin/support";
export const COMPLETE_PROFILE_PARTICIPANTS =
  "/complete-profile/:id/:organizationId/:isGuest/:isInsideRole/:isEmailExist";
export const PATH_360_PAGE =
  "/eqn-assets/:assetClass/:assetCategory/:assetMake/:assetModel/:id/:userId/:token";
export const CATEGORY_PAGE_PATH =
  "/:assetClass/:assetCategory/:assetMake/:assetModel/:id";
export const VERIFY_EMAIL = "/verify-email/:id";
export const ADMIN = "/admin";
export const AUTH = "/auth";
export const VERIFICATION = "/verification";
export const LOGOUT = "/logout";
export const ERROR = "/error";
export const ABC = "/abc";

// other files route
export const forceResetPwdLink = "/forceResetPwd";
export const adminUserProfileInfoLink =
  "/admin/user-profile/payment-information";
export const adminTransportCompanyNewLink = "/admin/transport-companies/new";
export const transportCompanyEditLink = "/admin/transport-companies/:id/edit";
export const financeCompanyLink = "/admin/finance-companies/:id/edit";
export const financeCompanyNewLink = "/admin/finance-companies/new";
export const adminUserPersonalProfileInfoLink =
  "/admin/user-profile/personal-information";
export const adminAllAssetsNew = "/admin/all-assets/new";
export const adminSavedCardsLink = "/admin/user-profile/saved-cards";
export const adminSavedCardsEditLink = "/admin/user-profile/saved-cards/edit";
export const adminSavedCardsNewLink = "/admin/user-profile/saved-cards/new";
export const adminRoleModuleLink = "/admin/roles-module";
export const adminRolePermissionLink = "/admin/roles-permissions";
export const adminRolePermissionEditLink = "/admin/roles-permissions/:id/edit";
export const adminRolePermissionNewLink = "/admin/roles-permissions/new";
export const adminRolePermissionUserLink =
  "/admin/user-profile/roles-permissions";
export const adminOrganizationListLink = "/admin/organizations-list";
export const adminOrganizationListEditLink =
  "/admin/organizations-list/:id/edit";
export const adminOrganizationListNewLink = "/organizations-list/new";
export const buyerSellerListEditLink = "/admin/buyer-seller-list/:id/edit";
export const modelPageEditLink = "/admin/asset-model/:id/edit";
export const modelPageNewLink = "/admin/asset-model/new";
export const subscriptionPageEditLINK = "/admin/subscription/:id/edit";
export const subscriptionPageNewLINK = "/admin/asset-make/new";
export const serviceOfferedEditLink = "/admin/service-offered/:id/edit";
export const serviceOfferedNewLink = "/admin/service-offered/new";
export const logisticTypeEditLink = "/admin/logistic-type/:id/edit";
export const logisticTypeNewLink = "/admin/logistic-type/new";
export const adminLogisticPartnerEditLink = "/admin/logistic-partner/:id/edit";
export const adminLogisticPartnerNewLink = "/admin/logistic-partner/new";
export const globalSettingEditLink = "/admin/global-setting/:id/edit";
export const globalSettingNewLink = "/admin/global-setting/new";
export const adminFinancePartnerEditLink = "/admin/finance-partner/:id/edit";
export const adminFinancePartnerNewLink = "/admin/finance-partner/new";

export const businessTypeEditLink = "/admin/business-type/:id/edit";
export const businessTypeNewLink = "/admin/business-type/new";
export const companyTypeNewLink = "/admin/company-type/new";
export const companyTypeEditLink = "/admin/company-type/:id/edit";
export const badgePageNewLink = "/admin/master-badges/new";
export const badgePageEditLink = "/admin/master-badges/:id/edit";
export const makePageNewLink = "/admin/asset-make/new";
export const makePageEditLink = "/admin/asset-make/:id/edit";
export const adminAssetCategoryNewLink = "/admin/asset-categories/new";
export const adminAssetCategoryEditLink = "/admin/asset-categories/:id/edit";
export const adminAssetCategoriesIdLink =
  "/admin/asset-categories/:id/sub-category";
export const adminAssetSubCategoryEditLink =
  "/admin/asset-categories/:id/edit-sub-category";
export const assetClassNewLink = "/admin/asset-class/new";
export const assetClassEditLink = "/admin/asset-class/:id/edit";
export const adminAllAssetsListLink = "/admin/all-assets/list";
export const adminAllAssetsEditAsigneeLink = "/admin/all-assets/#Id#/assignee";
export const wantToBuyNewLink = "/admin/want-to-buy-assets/new";
export const wantToBuyEditLink = "/admin/want-to-buy-assets/:id/edit";
export const sellerOfferNewLink = "/admin/seller-offer/new";
export const underNegotiationNewLink = "/admin/assets-under-negotiation/new";
export const adminPaymentViewLink =
  "/admin/user-profile/payment-information/view-transactions";
export const inspectionViewMoreLink = "/admin/inspection-list/view-more";
export const companyEmployeeNewLink =
  "/admin/user-profile/company-employees/new";
export const companyEmployeeEditLink =
  "/admin/user-profile/company-employees/edit";
export const companyEmployeeLink = "/admin/user-profile/company-employees";
export const companyLocationNewLink =
  "/admin/user-profile/company-Locations/new";
export const companyLocationEditLink =
  "/admin/user-profile/company-Locations/edit";
export const companyLocationLink = "/admin/user-profile/company-Locations";
export const inquiryEditIdLink = "/admin/inquiries/#Id";
export const errorLink = "/error/error-v1";
export const adminAllAssetIdLink = "/admin/all-assets/#Id#/edit";
export const locationEditIdLink = "/admin/all-assets/#locationId#/asset-detail";

// new routes
export const SEARCH_RESULT = "/search-result";
export const HOMEPAGE_PAGE = "/homepage";
